<template>
  <div class="d-flex justify-content-end align-items-center">
    <button
      class="style-icon-container"
      :class="cssClass ? cssClass : 'style-button-color'"
    >
      <i :class="iconClass"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "SmallCircleButton",
  props: {
    iconClass: {
      type: String,
      default: null,
    },
    cssClass: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.style-icon-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
  border: none;
}

.style-button-color {
  background-color: $text-blue;
}

.style-icon-container:active {
  transition: 0.2s;
  opacity: 0.8;
  background-color: $text-blue;
}
</style>
